enum Role {
  MANAGER = "Gestionnaire",
  SUPER_ADMIN = "Super-administrateur",
  ADMIN = "Administrateur",
  CITY = "Ville",
  PLACER = "Placier",
  MERCHANT = "Commerçant",
  CUSTOMER_SERVICE = "Service-client",
  GUEST = "Invité",
  HEAD_OF_OPERATION = "Responsable exploitation",
  HEAD_OF_PLACERS = "Superviseur-placier",
  WORKER = "Ouvrier",
  AUDITOR = "Auditeur",
  ACCOUNTANT = "Comptable",
  MANAGER_PLACER = "Gestionnaire-placier",
  COM_RSE = "Service Com - RSE",
}
type RoleEntity = {
  id: number;
  name: string;
  guard_name: string;
  created_at: string;
  updated_at: string;
  permissions: PermissionEntity;
};
type RoleWithPermissions = {
  id: number;
  name: string;
  permissions?: BasicPermissionInfo[];
};
type BasicPermissionInfo = Pick<PermissionEntity, "id" | "name"> & {
  description?: string | null;
  group?: PermissionGroupInfo | null;
};
type PermissionEntity = {
  id: number;
  name: string;
  guard_name: string;
  group_id: number;
  created_at: string;
  updated_at: string;
};
type PermissionGroupInfo = {
  id: number;
  name: string;
};

type PermissionGroup = {
  id: number;
  name: string;
  order: number | null;
};

export type { PermissionGroup, PermissionGroupInfo, RoleWithPermissions, BasicPermissionInfo, RoleEntity };
export default Role;
